import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TaAllertaDownloadRoutingModule } from './ta-allerta-download-routing.module';
import { NbCardModule } from '@nebular/theme';
import { TaAllertaDownloadComponent } from './ta-allerta-download.component';

@NgModule({
  imports: [
    CommonModule,
    TaAllertaDownloadRoutingModule,
    NbCardModule
  ],
  declarations: [TaAllertaDownloadComponent],
  exports:[TaAllertaDownloadComponent]
})
export class TaAllertaDownloadModule { }
